<div class="visibility-settings">
  <p class="description">
    Toggle to turn a metric on or off. If on, the metric will always display on
    the District Profile and Our Schools. Once a metric is on, you can limit
    display to specific school levels and schools on the School Profile. A
    school's data, if available, will always be included in district
    aggregations on the District Profile and Our Schools even if hidden on the
    school dashboards.
  </p>
  <div class="save-div">
    <button
      mat-raised-button
      (click)="save()"
      class="save-btn green-btn"
      [disabled]="!metricsState || metricsState.pending"
    >
      SAVE
    </button>
    <div *ngIf="metricsState?.savedSuccessfully?.metricVisibility">
      <p class="save-success-text">
        Saved! Changes can take up to 24 hours to display.
      </p>
    </div>
    <div *ngIf="metricsState?.errors?.metricVisibility">
      <p class="error-text">{{ metricsState.errors.metricVisibility }}</p>
    </div>
  </div>
  <div class="visibility-settings-table">
    <visibility-settings-table
      [metrics]="updatedMetrics"
      [schools]="schools"
    ></visibility-settings-table>
  </div>
  <mat-progress-spinner
    class="modal-spinner"
    [diameter]="75"
    [mode]="'indeterminate'"
    *ngIf="!metricsState || metricsState.pending"
  >
  </mat-progress-spinner>
</div>
